import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import PaginationResponse from '@/common/pagination/entities/pagination-response'
import Judge from '@/evaluations/entities/judge'

class JudgesService {
  // public async findOneAsync(id: string) {
  //     const res = await axios.get<Evaluation>(`evaluations?id=${id}`)
  //     return Responses.obj(res)
  //   }
  //   public async findAllPagedAsync(request: EvaluationFilter) {
  //     const res = await axios.post<PaginationResponse<Evaluation>>(`evaluations/find/paged`, request)
  //     return Responses.pagedList(res)
  //   }
  public async createAsync(entity: Judge) {
    const res = await axios.post<Judge>(`judges`, entity)
    return Responses.obj(res)
  }
  public async updateAsync(entity: Judge) {
    const res = await axios.put<Judge>(`judges`, entity)
    return Responses.obj(res)
  }

  public async deleteAsync(id: string) {
    await axios.post(`judges/delete?id=${id}`)
  }
}

export default new JudgesService()
